import { z } from 'zod';

/**
 * Zod schema for the sample "hello-world" flow. The shape is shared across
 * all steps; each step validates only the subset declared in its Step.fields.
 */
export const helloWorldSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().email('Enter a valid email address'),
  newsletter: z.boolean().default(false),
});

export type HelloWorldValues = z.infer<typeof helloWorldSchema>;

export const helloWorldDefaults: HelloWorldValues = {
  firstName: '',
  lastName: '',
  email: '',
  newsletter: false,
};
